<template>
  <div class="vg-field-wrapper" :class="{error}">
    <van-field class="vg-field"
               :class="{vertical: vertical}"
               v-bind="$attrs"
               v-on="$listeners">
      <template #label>
        <span>{{ label }}</span><span class="hint" v-if="hint">{{ hint }}</span>
      </template>
      <template #input>
        <slot class="vg-field-value"></slot>
      </template>
    </van-field>
    <div class="description" v-if="description">{{description}}</div>
    <slot name="description"/>
  </div>
</template>

<script>
import {Field} from "vant";

export default {
  name: "VgField",
  components: {
    'van-field': Field,
  },
  props: {
    label: String,
    description: String,
    hint: String,
    error: Boolean,
    vertical: Boolean,
  },
  // props: {
  //   label: {
  //     type: String,
  //     required: true,
  //   },
  //   value: {
  //     type: String,
  //   },
  //   // placeholder: {
  //   //   type: String,
  //   // }
  // },
  // methods: {
  //   onInput(value) {
  //     this.$emit("input", value);
  //   }
  // }
}
</script>

<style scoped>

.vg-field {
  padding: 6px 8px;
  font-size: 16px;
  color: #000;
  background-color: transparent;
}

.vg-field.vertical {
  align-items: flex-start;
  flex-direction: column;
}

.vg-field.vertical >>> .van-field__value {
  margin: 5px 0 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 5px;
}

.vg-field >>> .van-field__label {
  font-size: 16px;
  color: #000;
  white-space: nowrap;
}

.vg-field >>> input,
.vg-field >>> textarea {
  text-align: right;
}

.vg-field >>> input::placeholder,
.vg-field >>> textarea::placeholder {
  font-size: 16px;
  color: #B4B4B4;
}

.vg-field >>> .van-icon-arrow:before {
  color: #C8C8C8;
  font-size: 20px;
}

.vg-field-wrapper {
  border-radius: 10px;
  border: solid 2px transparent;
}

.error {
  background-color: rgba(255, 255, 255, 1);
  border: 2px dashed rgba(255, 0, 0, 1);
}

/*.vg-field > .vg-field-value {*/
/*  color: #B4B4B4;*/
/*}*/

/*----------*/

.vg-view-field-value {
  margin-left: 10px;
}

.vg-view-field-label {
  /*margin-bottom: 6px;*/
  /*font-size: 16px;*/
  /*font-weight: 600;*/
  color: #B4B4B4;
  line-height: 22px;
  /*font-weight: bold;*/
}

.vg-view-field-value {
  /*min-height: 20px;*/
  /*font-size: 14px;*/
  /*font-weight: 600;*/
  /*color: #333333;*/
  line-height: 20px;
}

.vg-view-field {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.vg-view-field.vertical {
  align-items: flex-start;
  flex-direction: column;
}

.vg-view-field.vertical .vg-view-field-value {
  margin: 5px 0 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 5px;
}

.vg-view-field.primary .vg-view-field-value {
  color: #4BA9F6;
}

.vg-view-field.error .vg-view-field-value {
  color: #FF3434;
}

.vg-field .hint {
  color: #BBBBBB;
}

.description {
  font-size: 14px;
  padding: 10px;
  color: #BBBBBB;
}

/*---------------*/


/*.vg-field {*/
/*  padding: 0;*/
/*}*/

/*.vg-field::after {*/
/*  display: none;*/
/*}*/

/*.vg-field >>> .van-field__label {*/
/*  margin: 0 10px 0 3px;*/
/*  display: flex;*/
/*  align-items: center;*/
/*  justify-content: flex-end;*/
/*  font-size: 16px;*/
/*  font-weight: 500;*/
/*  color: #333333;*/
/*  line-height: 22px;*/
/*}*/

/*.vg-field >>> .van-field__control {*/
/*  align-items: center;*/
/*  justify-content: flex-end;*/
/*  margin-right: 24px;*/
/*}*/

/*.vg-field >>> input.van-field__control {*/
/*  height: 46px;*/
/*  border-radius: 10px;*/
/*  font-size: 16px;*/
/*  font-weight: 400;*/
/*  color: #333333;*/
/*  line-height: 22px;*/
/*  text-align: right;*/
/*}*/

/*.vg-field >>> input.van-field__control::placeholder {*/
/*  color: #B4B1B1;*/
/*}*/


/*.vg-field >>> input.van-field__control {*/
/*  background: #F6F6F6;*/
/*  padding: 12px 9px;*/
/*}*/

</style>
